<div class="zwi-widget" [class.zwi-widget--top]="top">
  <ng-content></ng-content>
</div>
